<template>
  <section>
    <main role="main" class="container section">
      <h1 class="title is-3">Contact Us</h1>
      <div class="columns">
        <form
          @submit="checkForm"
          class="column"
          name="contact"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
        <!-- Hidden input for Netlify bot detector -->
        <input type="hidden" name="form-name" value="ask-question" />
          <b-field
            :message="$v.name.$error ? 'Name is required' : ''"
            :type="$v.name.$error ? 'is-danger' : ''"
            label="Name"
          >
            <b-input v-model.trim="$v.name.$model" type="text" name="name" />
          </b-field>
          <b-field
            :message="$v.email.$error ? 'Email is required' : ''"
            :type="$v.email.$error ? 'is-danger' : ''"
            name="email"
            label="Email"
          >
            <b-input v-model.trim="$v.email.$model" type="email" />
          </b-field>
          <b-field
            :message="$v.reason.$error ? 'Reason is required' : ''"
            :type="$v.reason.$error ? 'is-danger' : ''"
            label="Contact Reason"
          >
            <b-select v-model="$v.reason.$model" name="reason" placeholder="Select a reason">
              <option value="general-feedback">General Feedback</option>
              <option value="unsafe-product">Unsafe Product</option>
              <option value="business-request">Business Request</option>
            </b-select>
          </b-field>
          <b-field
            :message="$v.message.$error ? 'Message is required' : ''"
            :type="$v.message.$error ? 'is-danger' : ''"
            label="Message"
          >
            <div class="control">
              <textarea
                v-model="$v.message.$model"
                :class="[
                  $v.message.$error ? 'is-danger' : 'is-info ',
                  'textarea'
                ]"
                name="message"
                type="text"
                placeholder="Message"
              />
            </div>
          </b-field>
          <b-field>
            <div class="control">
              <button type="submit" class="button is-link">Submit</button>
            </div>
          </b-field>
        </form>
        <div class="column">
          <img
            class="image is-400x226"
            src="@/assets/chinchilla_contact.jpeg"
            alt="Chinchilla image"
          />
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'
import { getPageMeta } from '@/utils'

const meta = {
  pageTitle: 'Contact Us',
  pageDescription:
    "We'll try to get back to you within 24 hours. We cannot give any medical advice. Contact your veterinarian and have your chinchilla properly assessed.",
  pageURL: 'http://www.chinchillaessentials.com/contact',
  pageImg:
    'https://www.chinchillaessentials.com/img/chinchilla_baby_and_mother.jpeg'
}

export default {
  name: 'Contact',
  mixins: [validationMixin],
  metaInfo: () => getPageMeta(meta),
  data() {
    return {
      name: '',
      email: '',
      message: '',
      reason: ''
    }
  },
  methods: {
    toast(message, type) {
      this.$toast.open({
        message: message,
        type: type,
        duration: 5000,
        position: 'is-top'
      })
    },
    checkForm(e) {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.toast('Please complete the form.', 'is-danger')
        e.preventDefault()
        return
      }

      this.toast(
        'Email sent successfully! Thank you for your feedback.',
        'is-success'
      )
      this.resetForm()
    },
    resetForm() {
      this.name = ''
      this.email = ''
      this.message = ''
      this.reason = ''

      this.$nextTick(() => {
        this.$v.$reset()
      })
    }
    // submitForm() {
    //   this.$v.$touch()

    //   if (this.$v.$invalid) {
    //     this.toast('Please complete the form.', 'is-danger')
    //   } else {
    //     this.axios
    //       .post('/api/email', {
    //         name: this.name,
    //         email: this.email,
    //         message: this.message,
    //         reason: this.reason
    //       })
    //       .then(() => {
    //         this.toast(
    //           'Email sent successfully! Thank you for your feedback.',
    //           'is-success'
    //         )
    //         this.resetForm()
    //       })
    //       .catch(err => {
    //         this.toast('Something went wrong. Please try again.', 'is-danger')
    //         throw new Error(err)
    //       })
    //   }
    // }
  },
  validations: {
    email: {
      required,
      email
    },
    message: {
      required
    },
    name: {
      required
    },
    reason: {
      required
    }
  }
}
</script>
